import { ref } from 'vue';
import axios from 'axios';

const ANALYTICS_EVENTS = {
    VISIT: 'visits',
    STARTED_CHECKOUT: 'started_checkout',
    FILLED_NAME: 'filled_name',
    FILLED_EMAIL: 'filled_email',
    FILLED_PHONE: 'filled_phone',
    FILLED_DOCUMENT: 'filled_document',
    PIX_GENERATED: 'pix_generated',
    PIX_PAID: 'pix_paid',
    BOLETO_GENERATED: 'boleto_generated',
    BOLETO_PAID: 'boleto_paid',
    CC_ATTEMPT: 'cc_attempts',
    CC_APPROVED: 'cc_approved',
    CC_DENIED: 'cc_denied',
};

export function useOfferAnalytics(offerPublicId) {
    const dispatchedEvents = ref({});

    const trackEvent = async (event) => {
        if (dispatchedEvents.value[event]) {
            return false;
        }

        try {
            await axios.post(route('checkout.track-event'), {
                offer_public_id: offerPublicId,
                event: event,
            });

            dispatchedEvents.value[event] = true;
            return true;
        } catch (error) {
            console.error('Failed to track event:', event, error);
            return false;
        }
    };

    const trackFilledName = () => trackEvent(ANALYTICS_EVENTS.FILLED_NAME);
    const trackFilledEmail = () => trackEvent(ANALYTICS_EVENTS.FILLED_EMAIL);
    const trackFilledPhone = () => trackEvent(ANALYTICS_EVENTS.FILLED_PHONE);
    const trackFilledDocument = () => trackEvent(ANALYTICS_EVENTS.FILLED_DOCUMENT);
    const trackStartedCheckout = () => trackEvent(ANALYTICS_EVENTS.STARTED_CHECKOUT);
    const trackPixGenerated = () => trackEvent(ANALYTICS_EVENTS.PIX_GENERATED);
    const trackBoletoGenerated = () => trackEvent(ANALYTICS_EVENTS.BOLETO_GENERATED);
    const trackCcAttempt = () => trackEvent(ANALYTICS_EVENTS.CC_ATTEMPT);
    const trackCcApproved = () => trackEvent(ANALYTICS_EVENTS.CC_APPROVED);
    const trackCcDenied = () => trackEvent(ANALYTICS_EVENTS.CC_DENIED);

    const hasDispatchedEvent = (event) => !!dispatchedEvents.value[event];

    return {
        ANALYTICS_EVENTS,
        trackEvent,
        trackFilledName,
        trackFilledEmail,
        trackFilledPhone,
        trackFilledDocument,
        trackStartedCheckout,
        trackPixGenerated,
        trackBoletoGenerated,
        trackCcAttempt,
        trackCcApproved,
        trackCcDenied,
        hasDispatchedEvent,
        dispatchedEvents,
    };
}
